<template>
	
	<div v-if="videoPath" class="full-screen align-items-center justify-content-center">
		<div class="ratio ratio-16x9">
			<video id="fullscreen-video" :src="videoPath" controls loop autoplay></video>
		</div>
		<button class="carousel__button" id="close-video" title="Close" @click="closeVideo()">
			<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m19.5 4.5-15 15M4.5 4.5l15 15"></path></svg>
		</button>
	</div>

</template>

<script>
	export default {
		name: 'YachtVideo',
		props: ['videoPath'],
		emits: ["closeVideo"],
		methods: {
			closeVideo() {
				this.$emit('closeVideo')
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #close-video {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 2000;
    border: 0;
    background-color: transparent;
  }
  #close-video svg {
    stroke: #FFF;
    width: 24px;
    height: 24px;
  }
</style>
